<form [formGroup]="form" class='ot-modal-wrapper' [ngClass]="{'ot-content-supplies-header': contentSuppliesHeader}">
  <div class='ot-modal-header-wrapper'>
    <div class='ot-modal-title'>
      {{title}}
    </div>
  </div>

  <div class='ot-modal-content-wrapper'>
    <ng-template dialog-component-host></ng-template>
  </div>

  <div class='ot-modal-footer-wrapper'>
    <div class='ot-modal-footer'>
      <button type="button" (click)="primaryClick()" [disabled]="!isValid || !allowClose"
        class='ot-primary-button-modal'>{{primary}}</button>
      <button *ngIf="secondary.length > 0" type="button" (click)="secondaryClick()" [disabled]="!allowClose"
        class='ot-secondary-button-modal'>{{secondary}}</button>
    </div>
  </div>
</form>